import { Column, Container } from "@/components/ui/layout";
import { GetTheApp } from "@/containers/get-the-app";
import { Card, CardContent, View } from "@/components/ui";
import { useEffect } from "react";
import { useAuthState } from "@/store/auth";
import { SignUpStep } from "@/types/users";
import { SignUpContent } from "@/components/shared/login-register/signup-content";
import { AddAddressContent } from "@/components/shared/login-register/add-address-content";
import { useSignUp } from "@/components/hooks/auth/useSignUp";
import { useRoute } from "@/components/shared/router";
import { useAuth } from "@/components/shared/auth-provider";

export const SignUpPage = () => {
  const { replace } = useRoute();
  const {
    data: { signUpStep },
    setSignUpStep,
  } = useAuthState();

  const { isAuthenticated } = useAuth();

  useEffect(() => {
    setSignUpStep(SignUpStep.ValidateNumber);
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      replace({
        pageKey: "homepage",
      });
    }
  }, [isAuthenticated]);

  const { onSignUp, signUpError, signUpLoading } = useSignUp();

  return (
    <View className="mx-8 py-12">
      <Container>
        <Column desktop="8">
          <Card className="p-2">
            <CardContent>
              {signUpStep === SignUpStep.ValidateNumber ? (
                <SignUpContent isModal={false} />
              ) : (
                <AddAddressContent
                  isDefaultAddress
                  onAddAddress={onSignUp}
                  loading={signUpLoading}
                  error={signUpError || ""}
                />
              )}
            </CardContent>
          </Card>
        </Column>
        <Column desktop="4" mobile="none">
          <GetTheApp />
        </Column>
      </Container>
    </View>
  );
};
